const STATE_INICIAL = {
    tasks:{
        task: '',
        filter: 'all',
        sort: 'asc',
    },
    login: {
        email: '',
        password: ''
    },
    register:  {
        nombre:'',
        email: '',
        password: ''
    }
    
}

export default STATE_INICIAL ; 